import { useEffect, useRef } from "react";

import { AlphaGameIcon } from "../icons/AlphaGameIcon";

const WELCOME_PAGES = [
  {
    title: "Claim the Kingdom",
    body: "Three lanes divide the battlefield. Reduce the opposing Land's Control to zero to claim a lane. Claim two lanes to win.",
    visual: "Three lanes → reduce enemy Control → earn two Victory Banners",
    icon: "banner" as const,
  },
  {
    title: "Build Your Lane",
    body: "Lands provide territory and resources. Commanders enable normal attacks. Armies guard and require local Upkeep even without a Commander.",
    visual: "Land → Commander → Armies",
    icon: "commander" as const,
  },
  {
    title: "Follow the Turn",
    body: "Ready and Draw resolve automatically when there is no choice. Drag cards from your hand onto glowing lanes: Lands in Land, then Commanders or Armies in Command.",
    visual: "Land → Supply → Command → Battle → Cleanup",
    icon: "phase" as const,
  },
] as const;

export function AlphaTutorialOverlay({
  step,
  onBack,
  onNext,
  onSkip,
}: {
  readonly step: 0 | 1 | 2;
  readonly onBack: () => void;
  readonly onNext: () => void;
  readonly onSkip: () => void;
}) {
  const primaryRef = useRef<HTMLButtonElement>(null);
  const page = WELCOME_PAGES[step];
  const finalPage = step === WELCOME_PAGES.length - 1;

  useEffect(() => {
    primaryRef.current?.focus();
  }, [step]);

  return (
    <aside
      className="alpha-tutorial-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="alpha-welcome-title"
      aria-describedby="alpha-welcome-description"
    >
      <p className="alpha-kicker">Guided First Match · {step + 1} of 3</p>
      <div className="alpha-tutorial-overlay__icon" aria-hidden="true">
        <AlphaGameIcon name={page.icon} />
      </div>
      <h2 id="alpha-welcome-title">{page.title}</h2>
      <p id="alpha-welcome-description">{page.body}</p>
      <p className="alpha-tutorial-overlay__visual">{page.visual}</p>
      <div className="alpha-tutorial-overlay__actions">
        <button
          className="alpha-button alpha-button--secondary"
          type="button"
          disabled={step === 0}
          onClick={onBack}
        >
          Back
        </button>
        <button className="alpha-button alpha-button--secondary" type="button" onClick={onSkip}>
          Skip guide
        </button>
        <button
          ref={primaryRef}
          className="alpha-button alpha-button--primary"
          type="button"
          onClick={onNext}
        >
          {finalPage ? "Start Guided Match" : "Next"}
        </button>
      </div>
    </aside>
  );
}
